import React, { Component } from 'react'
import { withNamespaces } from "react-i18next"
import './listing_popular.scss'

class ListingPopular extends Component {
  render() {
    const { t } = this.props
    return (
      <div styleName="popular-listings">
        <h2 styleName="popular-heading">{t('vietnam.popular_heading')}</h2>
        <div styleName="city-cards-wrapper">
          <ul styleName="city-cards-upper">

            <li styleName="city-card card-upper hanoi">
              <a styleName="city-link" href={routeUrlHelper.countrySearchPath('vn', { adults: 2, destination: 'Ha noi', sort: 'distance_asc' })}>
                <div styleName="dark-layer">
                  <div styleName="city">
                    <h3 styleName="city-heading">{t('vietnam.hanoi')}</h3>
                  </div>
                </div>
              </a>
            </li>

            <li styleName="city-card card-upper hochiminh">
              <a styleName="city-link" href={routeUrlHelper.countrySearchPath('vn', { adults: 2, destination: 'Ho Chi Minh', sort: 'distance_asc' })}>
                <div styleName="dark-layer">
                  <div styleName="city">
                    <h3 styleName="city-heading">{t('vietnam.hochiminh')}</h3>
                  </div>
                </div>
              </a>
            </li>
          </ul>

        </div>

        <div styleName="city-cards-wrapper">
          <ul styleName="city-cards-lower">
            <li styleName="city-card card-lower halong">
              <a styleName="city-link" href={routeUrlHelper.countrySearchPath('vn', { adults: 2, destination: 'Ha Long', sort: 'distance_asc' })}>
                <div styleName="dark-layer">
                  <div styleName="city">
                    <h3 styleName="city-heading">{t('vietnam.halong')}</h3>
                  </div>
                </div>
              </a>
            </li>

            <li styleName="city-card danang">
              <a styleName="city-link" href={routeUrlHelper.countrySearchPath('vn', { adults: 2, destination: 'Da Nang', sort: 'distance_asc' })}>
                <div styleName="dark-layer">
                  <div styleName="city">
                    <h3 styleName="city-heading">{t('vietnam.danang')}</h3>
                  </div>
                </div>
              </a>
            </li>

            <li styleName="city-card nhatrang">
              <a styleName="city-link" href={routeUrlHelper.countrySearchPath('vn', { adults: 2, destination: 'Nha Trang', sort: 'distance_asc' })}>
                <div styleName="dark-layer">
                  <div styleName="city">
                    <h3 styleName="city-heading">{t('vietnam.Nhatrang')}</h3>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default withNamespaces('vietnam')(ListingPopular)
